var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSearchActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2601_11366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.577 23.5341L19.9767 17.9338C21.4252 16.054 22.2857 13.6995 22.2857 11.1429C22.2857 4.98952 17.2962 0 11.1429 0C4.98952 0 0 4.98952 0 11.1429C0 17.2962 4.98952 22.2857 11.1429 22.2857C13.6995 22.2857 16.054 21.4252 17.9338 19.9767L23.5341 25.577C23.8168 25.8597 24.1862 26 24.5556 26C24.9249 26 25.2943 25.8597 25.577 25.577C26.1403 25.0137 26.1403 24.0975 25.577 23.5341ZM2.88889 11.1429C2.88889 6.59079 6.59079 2.88889 11.1429 2.88889C15.6949 2.88889 19.3968 6.59079 19.3968 11.1429C19.3968 15.6949 15.6949 19.3968 11.1429 19.3968C6.59079 19.3968 2.88889 15.6949 2.88889 11.1429Z",
    fill: "#00C8D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2601_11366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchActive);
export default __webpack_public_path__ + "static/media/IconSearchActive.8a8436fed27f4582539f0865a718a91e.svg";
export { ForwardRef as ReactComponent };